module.exports = __webpack_public_path__ + "media/images/svg/mail-1cfe4bce99a7bee939373775d2ae8dbd.svg";